"use client";

import { useState } from "react";
import Input from "./Input";
import Field from "./Field";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";
import { isMobile } from "../../lib/utils";
import styles from "../../styles/Form.module.css";
import classNames from "classnames";

function PasswordField({
  autoComplete = "current-password",
  autoFocus = false,
  errorMessage,
  hideLabel,
  showLabel,
  value,
  onChange,
  inError,
  onBlur,
  requiredPlaceholder,
}) {
  const [showPassword, setShowPassword] = useState(isMobile());
  const Icon = showPassword ? EyeSlashIcon : EyeIcon;
  const label = showPassword ? hideLabel : showLabel;

  return (
    <div className="relative w-72">
      <Input
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className="w-72 pr-20 relative"
        inError={inError}
        onBlur={onBlur}
        onChange={onChange}
        required={Boolean(errorMessage)}
        value={value}
        requiredPlaceholder={requiredPlaceholder}
        type={showPassword ? "text" : "password"}
      />
      <button
        type="button"
        aria-label={label}
        className={classNames(
          styles.link,
          "rounded-md absolute top-1.5 right-2 font-light flex items-center gap-x-1 mt-1.5 text-sm  text-gray-400",
        )}
        onClick={() => setShowPassword(!showPassword)}
      >
        {label}
        <Icon className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}

function Password({
  autoComplete = "current-password",
  autoFocus,
  errorMessage,
  fieldValidations = {},
  fieldName,
  hideLabel,
  label,
  labelColorClass,
  requiredPlaceholder,
  showLabel,
}: {
  autoComplete?: string;
  autoFocus?: boolean;
  errorMessage: string;
  fieldName: string;
  fieldValidations?: { [key: string]: string };
  hideLabel?: string;
  label: string;
  labelColorClass?: string;
  requiredPlaceholder?: string;
  showLabel?;
  string;
}): JSX.Element | null {
  return (
    <Field
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <PasswordField
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          errorMessage={errorMessage}
          value={value}
          onChange={onChange}
          hideLabel={hideLabel}
          inError={inError}
          onBlur={onBlur}
          requiredPlaceholder={requiredPlaceholder}
          showLabel={showLabel}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage, ...fieldValidations }}
      label={label}
      labelColorClass={labelColorClass}
    />
  );
}

export default Password;
